import { CustomerCertificateStatus } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllCustomerCertificateStatuses = () =>
  getAllEnumOptions(CustomerCertificateStatus)

export const getCustomerCertificateStatusLabel = (
  key?: CustomerCertificateStatus,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return CustomerCertificateStatus[key]
}
